// extracted by mini-css-extract-plugin
export default {"plugin-settings__title":"PluginSettings_plugin-settings__title__Ir6jr"};